import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { BulkAssignServiceRequestsProps } from './types';

type UnassignServiceRequestsFromFirmParams = {
  agentFirmId: string;
  data: BulkAssignServiceRequestsProps;
};

export async function unassignServiceRequestsFromFirm({
  agentFirmId,
  data,
}: UnassignServiceRequestsFromFirmParams) {
  const response = await fetcher(`${API_BASE_PATH}/${agentFirmId}/unassign`, {
    method: 'POST',
    body: data,
  });

  if (!response.ok) {
    const responseData = await response.json();
    return {
      success: false,
      error:
        responseData?.message ||
        'Failed to unassign service requests from firm',
      statusCode: response.status,
    };
  }

  return {
    success: true,
  };
}
